import React, { useEffect, useState } from 'react';

import {
  Box,
} from '@mui/joy';
import SeparatorBreadcrumbs from '../../Components/SeparatorBreadcrumbs';
import ButtonAttribute from '../../Components/ButtonAttribute';
import { faDownload, faCheck, faCloudArrowUp, faFileExport, faFileImport, faPen, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGridTable from '../../Components/TableData';
import { Checkbox, createTheme, Divider, FormControlLabel, Grid, Grid2, Switch, ThemeProvider, Typography } from '@mui/material';
import BasicModal from '../../Components/BasicModel';
import axios from 'axios';
import { API } from '../../API/api';
import TextInputMui from '../../Components/TextInputMui';
import AlertBar from '../../Components/AlertBar';
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import CustomizedProgressBars from '../../Components/CustomizedProgressBars';
import DateTimePickerComponent from '../../Components/DateTimePicker';
import AutocompleteComboBox from '../../Components/AutocompleteComboBox';
import { logOperation } from "../../API/logOperation";
import dayjs from 'dayjs';
const theme = createTheme({
  typography: { 
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: '-0.025em'
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.025em'
    },
    body1: {
      fontWeight: 500
    }
  },
  palette: { 
    mode: 'light', 
    primary: { 
      main: '#3b82f6',
      light: '#8b9eff',
      dark: '#2563eb'
    },
    secondary: {
      main: '#8b5cf6',
      light: '#a78bfa',
      dark: '#7c3aed'
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff'
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }
      }
    }
  }
});



export default function Vehicules() {
  const [ImportData, setImportData] = useState();
  const [isLoading, setIsLoading] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Vehicules, setVehicules] = useState([]);
  const [openAjouterVehicule, setOpenAjouterVehicule] = React.useState(false);
  const [rowsSelected, setRowsSelected] = React.useState({});
  const handleOpen = () => setOpenAjouterVehicule(true);
  const handleClose = () => setOpenAjouterVehicule(false);
  const [Permissions, setPermissions] = useState([]);
  const [role, setRole] = useState([]);

  {/* modifier Vehicule */ }
  const [openModifierVehicule, setOpenModifierVehicule] = React.useState(false);
  const handleOpenModifier = () => {
    const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
    if (selectedRows.length > 0) {
      setOpenModifierVehicule(true);
      setRowsSelected(selectedRows);
      setModifierVehicule(selectedRows[0]);
    }
    else {
      setAlertOpenSelectedModifier(true);
    }
  }
  const handleCloseModifier = () => {
    setOpenModifierVehicule(false);
  }

  const [alertOpenSelectedModifier, setAlertOpenSelectedModifier] = useState(false);
  const handleAlertCloseSelectedModifier = () => { setAlertOpenSelectedModifier(false); }
  const [alertOpenNotModiferRow, setAlertOpenNotModiferRow] = useState(false);
  const handleAlertCloseNotModiferRow = () => { setAlertOpenNotModiferRow(false); }
  const handleAlertOpenNotModiferRow = () => { setAlertOpenNotModiferRow(true); }
  const [alertOpenUpdatedVehicule, setAlertOpenUpdatedVehicule] = useState(false);
  const handleAlertCloseUpdatedVehicule = () => { setAlertOpenUpdatedVehicule(false); }
  const handleAlertOpenUpdatedVehicule = () => { setAlertOpenUpdatedVehicule(true); }

  // UPDATE
  const [isUpdatingVehicule, setIsUpdatingVehicule] = useState(false);
const handleOpenModifierOneVehicule = async () => {
  if (isUpdatingVehicule) return;
  const stored = sessionStorage.getItem('authLocalstorage');
  const parsed = stored ? JSON.parse(stored) : null;
  const token = parsed?.token;
  if (!token) { setErrors({ error: true, message: "Session expirée." }); return; }

  const ID = modifierVehicule?.id || rowsSelected?.[0]?.id;
  if (!ID) { setErrors({ error: true, message: "Véhicule non sélectionné." }); return; }

  // helpers
  const v_toStr  = (v) => { const s = String(v ?? '').trim(); return s || null; };
  const v_toNum  = (v) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : null; };
  const v_toInt  = (v) => { const n = parseInt(v, 10); return Number.isFinite(n) ? n : null; };
  const v_toBool = (v) => (String(v) === '1' || v === 1 || v === true || String(v).toLowerCase() === 'oui');
  const v_toISO  = (v) => { const d = dayjs(v); return d.isValid() ? d.format('YYYY-MM-DD') : null; };

  // unchanged check (normalize both sides)
  const original = rowsSelected?.[0] || {};
  const norm = (x) => ({
    code_vehicule: v_toStr(x.code_vehicule),
    id_chauffeur:  v_toInt(x.id_chauffeur),
    marque:        v_toStr(x.marque),
    matricule:     v_toStr(x.matricule),
    type_moyen:    v_toStr(x.type_moyen),
    numero_chassis: v_toStr(x.numero_chassis),
    premiere_mise_en_circulation: v_toISO(x.premiere_mise_en_circulation),
    premiere_mise_au_maroc:       v_toISO(x.premiere_mise_au_maroc),
    ptac:        v_toNum(x.ptac),
    poids_vide:  v_toNum(x.poids_vide),
    date_acquisition: v_toISO(x.date_acquisition),
    type_acquisition: v_toStr(x.type_acquisition),
    valeur_achat:     v_toNum(x.valeur_achat),
    date_premier_prelevement: v_toISO(x.date_premier_prelevement),
    date_dernier_prelevement: v_toISO(x.date_dernier_prelevement),
    nombre_prelevements:      v_toInt(x.nombre_prelevements),
    montant_loyer_ttc:        v_toNum(x.montant_loyer_ttc),
    carburant: v_toStr(x.carburant),
    numero_police_assurance:  v_toStr(x.numero_police_assurance),
    date_expiration_assurance: v_toISO(x.date_expiration_assurance),
    gps_installe: v_toBool(x.gps_installe),
    statut:       v_toStr(x.statut),
  });

  const before = norm(original);
  const after  = norm(modifierVehicule);
  const unchanged = JSON.stringify(before) === JSON.stringify(after);
  if (unchanged) { handleAlertOpenNotModiferRow(); return; }

  // required
  const req = [
    ['code_vehicule', 'Code véhicule'],
    ['marque', 'Marque'],
    ['matricule', 'Matricule'],
    ['type_moyen', 'Type moyen'],
  ];
  const miss = req.filter(([k]) => !modifierVehicule[k] || String(modifierVehicule[k]).trim() === '');
  if (miss.length) {
    setErrorsModifier({
      error: true,
      message: `Champs requis: ${miss.map(([,l])=>l).join(', ')}`,
    });
    return;
  }

  if (String(modifierVehicule.type_acquisition).toLowerCase() === 'leasing') {
    const leasingMissing = [];
    if (!modifierVehicule.date_premier_prelevement) leasingMissing.push('Date premier prélèvement');
    if (!modifierVehicule.date_dernier_prelevement) leasingMissing.push('Date dernier prélèvement');
    if (!modifierVehicule.montant_loyer_ttc) leasingMissing.push('Montant loyer TTC');
    if (!modifierVehicule.nombre_prelevements) leasingMissing.push('Nombre prélèvements');
    if (leasingMissing.length) {
      setErrorsModifier({ error:true, message:`Champs leasing requis: ${leasingMissing.join(', ')}` });
      return;
    }
  }

  const body = after; // already normalized

  try {
    setIsUpdatingVehicule(true);
    const res = await axios.put(`${API}/vehicules/${ID}`, body, {
      headers: { Authorization: `Bearer ${token}` },
    });

    handleAlertOpenUpdatedVehicule();
    handleCloseModifier();
    await fetchVehicules(token);
    setErrorsModifier({ error:false, message:'' });

    logOperation({
      operation_type: "MODIFICATION",
      entity_type: "Vehicule",
      entity_id: parsed?.user?.id,
      description: `Modification véhicule ${ID}`,
    });
  } catch (e) {
    const msg = e?.response?.data?.message || e?.response?.data?.error || "Erreur lors de la modification.";
    setErrors({ error:true, message: msg });
    console.error(e?.response?.data || e);
  } finally {
    setIsUpdatingVehicule(false);
  }
};




  {/* end modifier Vehicule */ }

  const [errors, setErrors] = useState(false);
  const [errorsModifer, setErrorsModifier] = useState({
    key: '',
    message: ''
  });
  const [alertOpen, setAlertOpen] = useState(false);

  const handleAlertClose = () => { setAlertOpen(false); };
  // state
  const emptyVehicule = {
    code_vehicule: "",
    id_chauffeur: "",
    marque: "",
    matricule: "",
    type_moyen: "",
    numero_chassis: "",
    premiere_mise_en_circulation: "",
    premiere_mise_au_maroc: "",
    ptac: "",
    poids_vide: "",
    date_acquisition: "",
    type_acquisition: "",              // "leasing" | "comptant"
    valeur_achat: "",
    date_premier_prelevement: "",
    date_dernier_prelevement: "",
    nombre_prelevements: "",
    montant_loyer_ttc: "",
    carburant: "",
    numero_police_assurance: "",
    date_expiration_assurance: "",
    gps_installe: false,               // boolean
    statut: "actif",                   // enum
  };

  const [newVehicule, setNewVehicule] = useState({ ...emptyVehicule });
  const [modifierVehicule, setModifierVehicule] = useState({ ...emptyVehicule });


  const handleModifierSelectionChangeChauffeur = (key, value) => {
    setModifierVehicule((prev) => ({
      ...prev,
      id_chauffeurs: key, // Assign the selected key to ID_Client
    }));
  };

  {/* Delete Vehicule */ }
  const [alertOpenDeletedVehicule, setAlertOpenDeletedVehicule] = useState(false);
  const handleAlertCloseDeletedVehicule = () => { setAlertOpenDeletedVehicule(false); }
  const handleAlertOpenDeletedVehicule = () => { setAlertOpenDeletedVehicule(true); }
  const [alertOpenMultiDeletedVehicule, setAlertMultiOpenDeletedVehicule] = useState(false);
  const handleAlertMultiCloseDeletedVehicule = () => { setAlertMultiOpenDeletedVehicule(false); }
  const handleAlertMultiOpenDeletedVehicule = () => { setAlertMultiOpenDeletedVehicule(true); }
  const [openDeleteVehicule, setOpenDeleteVehicule] = useState(false);
  const [alertOpenPasswordNotValid, setAlertOpenPasswordNotValid] = useState(false);
  const handleAlertClosePasswordNotValid = () => { setAlertOpenPasswordNotValid(false); }
  const handleAlertOpenPasswordNotValid = () => { setAlertOpenPasswordNotValid(true); }
  const handleOpenDeleteVehicule = () => {
    const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
    if (selectedRows.length > 0) {
      setOpenDeleteVehicule(true);
      setRowsSelected(selectedRows);
      setModifierVehicule(selectedRows[0]);
    }
    else {
      setAlertOpenSelectedModifier(true);
    }

  }
  const handleCloseDeleteVehicule = () => { setOpenDeleteVehicule(false); }
  const handleDeleteVehicule = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const ID = modifierVehicule.id;

    try {
      // Make the DELETE request
      const response = await axios.delete(`${API}/vehicules/${ID}`, {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` }
      });
      // Handle the response

      handleCloseDeleteVehicule();
      setAlertOpenDeletedVehicule(true);
      logOperation({
        operation_type: "DELETE",
        entity_type: "vehicules",
        entity_id: parsedAuthState.user.id,
        description: "Supprimer vehicule",
      });
    }
    catch (error) {
      // Handle errors
      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        console.error('Error Response:', error.response.data.error);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error Request:', error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error Message:', error.message);
      }
    }



  }
  const handleDeleteMultiVehicules = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);

    //const ID = modifierVehicule.id;
    try {
      // Make the DELETE request
      const promises = rowsSelected.map((row) => {
        return axios.delete(`${API}/vehicules/${row.id}`, {
          headers: { Authorization: `Bearer ${parsedAuthState.token}` }
        });
      });
      const responses = await Promise.all(promises); // Wait for all deletions to complete

      handleCloseDeleteVehicule();
      handleAlertMultiOpenDeletedVehicule();
      logOperation({
        operation_type: "DELETE MULTIPLE",
        entity_type: "vehicules",
        entity_id: parsedAuthState.user.id,
        description: "Supprimer vehicules",
      });
    }
    catch (error) {
      // Handle errors
      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        console.error('Error Response:', error.response.data.error);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error Request:', error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error Message:', error.message);
      }
    }
  }

  const handleVerificationPassword = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const email = parsedAuthState.user.email;
    const password = ConfrimedPassword.password;

    axios
      .post(`${API}/verify-password`, { email, password })
      .then((response) => {
        if (response.data.success) {
          if (rowsSelected.length === 1) {
            handleDeleteVehicule();
          } else {
            handleDeleteMultiVehicules();
          }
          handleCloseConfirmationPassword();
          fetchVehicules(parsedAuthState.token);
        } else {
          // Handle unexpected responses where success is false
          setConfirmedPassword({
            errors: true,
          });
          console.error("Password verification failed:", response.data);
          handleAlertOpenPasswordNotValid();
        }
      })
      .catch((error) => {
        // Handle errors from the server or network issues
        if (error.response) {
          // Server responded with a status other than 2xx
          console.error("Error response:", error.response.data);
          setConfirmedPassword({
            errors: true,
          });
          handleAlertOpenPasswordNotValid();
        } else if (error.request) {
          // Request was made but no response received
          console.error("No response received:", error.request);
        } else {
          // Something else happened
          console.error("Error setting up request:", error.message);
        }
      });

  }


  {/* End Delete Vehicule */ }

  {/* Begin Extration Vehicule */ }
  const [openExtrationVehicule, setOpenExtrationVehicule] = useState(false);
  const handleCloseExtrationVehicule = () => { setOpenExtrationVehicule(false); }
  const handleOpenExtrationVehicule = () => { setOpenExtrationVehicule(true); }
  const [alertOpenNotSelectedLineExtration, setAlertOpenNotSelectedLineExtration] = useState(false);
  const handleAlertOpenNotSelectedLineExtration = () => { setAlertOpenNotSelectedLineExtration(true) };
  const handleAlertCloseNotSelectedLineExtration = () => { setAlertOpenNotSelectedLineExtration(false) };
  const handleExtrationAllVehicule = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);

    // Préparation des données à exporter
    const exportData = Vehicules.map((vehicule) => {
      const row = {};
      columns.forEach((col) => {
        row[col.header] = vehicule[col.accessorKey] ?? "";
      });
      return row;
    });

    // Génération de la feuille Excel
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Véhicules");

    // Générer un fichier binaire Excel
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(blob, "Vehicules.xlsx");

    // Log de l’opération
    logOperation({
      operation_type: "Extraction",
      entity_type: "vehicules",
      entity_id: parsedAuthState.user.id,
      description: "Extraction de tous les véhicules",
    });
  };
  const handleExtrationSelectionsVehicules = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);

    const selectedRows = JSON.parse(localStorage.getItem('selectedRows'));

    if (selectedRows && selectedRows.length > 0) {
      // Convert selected rows to exportable format using column headers
      const exportData = selectedRows.map((vehicule) => {
        const row = {};
        columns.forEach((col) => {
          row[col.header] = vehicule[col.accessorKey] ?? ''; // Use header as key
        });
        return row;
      });

      // Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Vehicules Sélectionnés");

      // Create Excel file as Blob
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Trigger file download
      saveAs(blob, "Vehicules_selectionnes.xlsx");

      // Log the operation
      logOperation({
        operation_type: "Extraction",
        entity_type: "Vehicules",
        entity_id: parsedAuthState.user.id,
        description: "Extraction des véhicules sélectionnés",
      });

    } else {
      handleAlertOpenNotSelectedLineExtration();
    }
  };
  {/* End Extration Vehicule */ }

  {/* Begin importation Vehicule */ }
  const [openImportationVehicule, setOpenImportationVehicule] = useState(false);
  const handleCloseImportationVehicule = () => { setOpenImportationVehicule(false); }
  const handleOpenImportationVehicule = () => { setOpenImportationVehicule(true); }
  const [alertOpenImport, setAlertOpenImport] = useState(false);
  const handleAlertOpenImport = () => { setAlertOpenImport(true); }
  const handleCloseAlertImport = () => { setAlertOpenImport(false); }
  const [alertErrorImport, setAlertErrorImport] = useState(false);
  const handleOpenErrorAlertImport = () => { setAlertErrorImport(true); }
  const handleCloseErrorAlertImport = () => { setAlertErrorImport(false); }
  // Function to handle file download
  const handleDownload = () => {
    const filePath = `/ImportVehicules.xlsx`; // Adjust the path and filename as needed
    const link = document.createElement('a');
    link.href = filePath;
    link.download = 'ImportVehicules.xlsx'; // Name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const triggerFileInput = () => {
    document.getElementById("file-upload").click();
  };

  // Handle file import and parse the Excel file
  const handleFileImport = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  const storedAuthState = sessionStorage.getItem('authLocalstorage');
  const parsedAuthState = JSON.parse(storedAuthState || '{}');

  const requiredFields = [
    "Code Vehicule", "ID Chauffeurs", "Marque", "Matricule"
  ];

  const convertExcelDate = (value) => {
    if (value == null || value === "") return null;
    if (typeof value === "number") {
      const excelStartDate = new Date(1899, 11, 30);
      return new Date(excelStartDate.getTime() + value * 86400000).toISOString().split("T")[0];
    }
    if (typeof value === "string") {
      const s = value.trim();
      const ddmmyyyy = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/);
      if (ddmmyyyy) {
        const [_, d, m, y] = ddmmyyyy;
        const yyyy = y.length === 2 ? `20${y}` : y;
        return `${yyyy}-${String(m).padStart(2,"0")}-${String(d).padStart(2,"0")}`;
      }
      const d = new Date(s);
      if (!Number.isNaN(d.getTime())) return d.toISOString().split("T")[0];
    }
    return null;
  };

  const toBool = (v) => {
    if (typeof v === 'boolean') return v;
    const s = String(v ?? '').trim().toLowerCase();
    return ['1','true','vrai','oui','yes','y','x'].includes(s);
  };

  reader.onload = async (e) => {
    const binaryStr = e.target.result;
    const workbook = XLSX.read(binaryStr, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
    const totalRows = jsonData.length;

    let processedRows = 0;
    setIsLoading(0);

    try {
      for (let i = 0; i < jsonData.length; i++) {
        const row = jsonData[i];

        // validate required
        for (const field of requiredFields) {
          if (!row[field] || String(row[field]).trim() === '') {
            setIsLoading(0);
            alert(`❌ Ligne ${i + 2} : le champ "${field}" est vide ou invalide.`);
            return;
          }
        }

        // payload mapped to your API model
        const payload = {
          code_vehicule: String(row["Code Vehicule"]).trim(),
          id_chauffeur: row["ID Chauffeurs"],
          marque: String(row["Marque"]).trim(),
          matricule: String(row["Matricule"]).trim(),
          type_moyen: String(row["Type Moyen"]).trim(),
          numero_chassis: String(row["Numero Chassis"]).trim(),
          premiere_mise_en_circulation: convertExcelDate(row["Premiere Mise en Circulation"]),
          premiere_mise_au_maroc: convertExcelDate(row["Premiere Mise au Maroc"]),
          ptac: row["PTAC"],
          poids_vide: row["Poids Vide"],
          date_acquisition: convertExcelDate(row["Date Acquisition"]),
          type_acquisition: String(row["Type Acquisition"] || '').toLowerCase(), // 'leasing' | 'comptant'
          valeur_achat: row["Valeur Achat"],
          date_premier_prelevement: convertExcelDate(row["Date Premier Prelevement"]),
          date_dernier_prelevement: convertExcelDate(row["Date Dernier Prelevement"]),
          nombre_prelevements: row["Nombre Prelevements"],
          montant_loyer_ttc: row["Montant Loyer TTC"],
          carburant: String(row["Carburant"]).trim(),
          numero_police_assurance: String(row["Numero Police Assurance"]).trim(),
          date_expiration_assurance: convertExcelDate(row["Date Expiration Assurance"]),
          gps_installe: toBool(row["GPS Installe"]),
          statut: (row["Statut"] || 'actif').toString().toLowerCase(),
        };

        await axios.post(`${API}/vehicules`, payload, {
          headers: { Authorization: `Bearer ${parsedAuthState.token}` },
        });

        processedRows += 1;
        setIsLoading((processedRows / totalRows) * 100);
      }

      setTimeout(() => {
        handleAlertOpenImport();
        handleCloseImportationVehicule();
        setIsLoading(0);
        fetchVehicules(parsedAuthState.token);
        logOperation({
          operation_type: "Importation",
          entity_type: "vehicules",
          entity_id: parsedAuthState.user.id,
          description: `Import véhicules: ${processedRows}/${totalRows} lignes`,
        });
      }, 500);
    } catch (error) {
      console.error("Échec de l'importation :", error?.response?.data || error);
      handleOpenErrorAlertImport();
      setIsLoading(0);
    }
  };

  reader.readAsBinaryString(file);
};



  {/* end importation Vehicule */ }

  {/* Begin Confirm password for delete Vehicule */ }

  const [openConfirmationPassword, setOpenConfirmationPassword] = useState(false);
  const handleCloseConfirmationPassword = () => { setOpenConfirmationPassword(false); }
  const handleOpenConfirmationPassword = () => { setOpenConfirmationPassword(true); }
  const [ConfrimedPassword, setConfirmedPassword] = useState({
    password: "",
    errors: "",
  });
  const [alertOpenConfirmDeleteVehicule, setAlertOpenConfirmDeleteVehicule] = useState(false);
  const handleAlertOpenConfirmDeleteVehicule = () => { setAlertOpenConfirmDeleteVehicule(true); }
  const handleCloseAlertConfirmDeleteVehicule = () => { setAlertOpenConfirmDeleteVehicule(false); }

  {/* End Confirm password for delete Vehicule */ }

  const MenuButton = () => {
    return (
       <Box sx={{ 
                backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb4b',
                borderRadius: '32px',
                padding: { xs: '20px', md: '30px' },
                marginBottom: '20px',
                boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)", 
            }}>    

        {/* Header Section */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          marginBottom: '20px',
          paddingBottom: '16px',
          borderBottom: '1px solid #f3f4f6'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Box sx={{
              width: '40px',
              height: '40px',
              borderRadius: '6px',
              backgroundColor: '#3b82f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <FontAwesomeIcon icon={faCloudArrowUp} style={{ color: 'white', fontSize: '16px' }} />
            </Box>
            <Typography variant="h4" sx={{ 
              fontWeight: 600, 
              color: '#1f2937', 
              fontSize: { xs: '1.25rem', md: '1.5rem' },
              letterSpacing: '-0.025em'
            }}>
              Gestion des Véhicules
            </Typography>
          </Box>
          
          <Typography variant="body2" sx={{ 
            color: '#6b7280',
            fontSize: '14px',
            fontWeight: 500,
            backgroundColor: '#f9fafb',
            padding: '6px 12px',
            borderRadius: '6px',
            border: '1px solid #e5e7eb'
          }}>
            {Vehicules.length} véhicule{Vehicules.length !== 1 ? 's' : ''}
          </Typography>
        </Box>

        {/* Action Buttons Section */}
                <Box sx={{ 
                    display: 'flex', 
                    flexWrap: 'wrap',
                    gap: '20px',
                    marginTop: '30px',
                    alignItems: 'center',
                    justifyContent: { xs: 'center', md: 'space-between' }
                }}>
          {/* Primary Actions */}
          <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {isAllowedAjouterVehicule == 1 && (
              <ButtonAttribute
                Label="Ajouter"
                action={handleOpen}
                Bgcolor="#3b82f6"
                color="white"
                bgColorHover="#2563eb"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faPlus} style={{ fontSize: '14px' }} />}
                hidden={true}
               
              />
            )}
            {isAllowedModifierVehicule == 1 && (
              <ButtonAttribute
                Label="Modifier"
                action={handleOpenModifier}
                Bgcolor="#f59e0b"
                color="white"
                bgColorHover="#d97706"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faPen} style={{ fontSize: '14px' }} />}
                hidden={true}
               
              />
            )}
            {isAllowedSupprimerVehicule == 1 && (
              <ButtonAttribute
                Label="Supprimer"
                action={handleOpenDeleteVehicule}
                Bgcolor="#ef4444"
                color="white"
                bgColorHover="#dc2626"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faTrash} style={{ fontSize: '14px' }} />}
                hidden={true}
               
              />
            )}
          </Box>

          {/* Secondary Actions */}
          <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {isAllowedExporterVehicule == 1 && (
              <ButtonAttribute
                Label="Exporter"
                action={handleOpenExtrationVehicule}
                Bgcolor="#8b5cf6"
                color="white"
                bgColorHover="#7c3aed"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faFileExport} style={{ fontSize: '14px' }} />}
                hidden={true}
               
              />
            )}
            {isAllowedImporterVehicule == 1 && (
              <ButtonAttribute
                Label="Importer"
                action={handleOpenImportationVehicule}
                Bgcolor="#10b981"
                color="white"
                bgColorHover="#059669"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faFileImport} style={{ fontSize: '14px' }} />}
                hidden={true}
                
              />
            )}
          </Box>
        </Box>
      </Box>
    );
  };


 const fmtDate = (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "");
const fmtNum  = (v) =>
  v === null || v === undefined || v === "" ? "" :
  Number(v).toLocaleString("fr-FR", { maximumFractionDigits: 2 });

 const columns = [
  { accessorKey: 'id', header: 'ID Véhicule', size: 80 },

  { accessorKey: 'code_vehicule', header: 'Code véhicule', size: 160 },

  {
    accessorKey: 'id_chauffeur',
    header: 'Chauffeur',
    size: 200,
    Cell: ({ cell }) => {
      const idChauffeur = cell.getValue();
      const c = chauffeurs.find((x) => String(x.id) === String(idChauffeur));
      return c ? `${c.Nom} ${c.Prénom}` : '';
    },
  },

  { accessorKey: 'marque', header: 'Marque', size: 150 },
  { accessorKey: 'matricule', header: 'Matricule', size: 150 },
  { accessorKey: 'type_moyen', header: 'Type moyen', size: 150 },

  { accessorKey: 'numero_chassis', header: 'N° châssis', size: 180 },

  {
    accessorKey: 'premiere_mise_en_circulation',
    header: '1ère mise en circulation',
    size: 180,
    Cell: ({ cell }) => fmtDate(cell.getValue()),
  },
  {
    accessorKey: 'premiere_mise_au_maroc',
    header: '1ère mise au Maroc',
    size: 180,
    Cell: ({ cell }) => fmtDate(cell.getValue()),
  },

  { accessorKey: 'ptac', header: 'PTAC', size: 110, Cell: ({ cell }) => fmtNum(cell.getValue()) },
  { accessorKey: 'poids_vide', header: 'Poids à vide', size: 120, Cell: ({ cell }) => fmtNum(cell.getValue()) },

  {
    accessorKey: 'date_acquisition',
    header: 'Date acquisition',
    size: 160,
    Cell: ({ cell }) => fmtDate(cell.getValue()),
  },

  { accessorKey: 'type_acquisition', header: 'Type acquisition', size: 160 },

  { accessorKey: 'valeur_achat', header: 'Valeur achat (MAD)', size: 170, Cell: ({ cell }) => fmtNum(cell.getValue()) },

  {
    accessorKey: 'date_premier_prelevement',
    header: '1er prélèvement',
    size: 160,
    Cell: ({ cell }) => fmtDate(cell.getValue()),
  },
  {
    accessorKey: 'date_dernier_prelevement',
    header: 'Dernier prélèvement',
    size: 170,
    Cell: ({ cell }) => fmtDate(cell.getValue()),
  },

  { accessorKey: 'nombre_prelevements', header: 'Nb prélèvements', size: 150 },

  {
    accessorKey: 'montant_loyer_ttc',
    header: 'Loyer TTC',
    size: 140,
    Cell: ({ cell }) => fmtNum(cell.getValue()),
  },

  { accessorKey: 'carburant', header: 'Carburant', size: 120 },

  { accessorKey: 'numero_police_assurance', header: 'N° police assurance', size: 180 },

  {
    accessorKey: 'date_expiration_assurance',
    header: 'Expiration assurance',
    size: 170,
    Cell: ({ cell }) => fmtDate(cell.getValue()),
  },

  {
    accessorKey: 'gps_installe',
    header: 'GPS installé',
    size: 120,
    Cell: ({ cell }) => (Number(cell.getValue()) ? 'Oui' : 'Non'),
  },

  { accessorKey: 'statut', header: 'Statut', size: 120 },
];





  // Function to get the 'allowed' value for a specific action
  const getPermission = (permissions, section, actionName) => {
    const sectionPermissions = permissions.find((perm) => perm.name === section);
    if (!sectionPermissions) return 0;

    const action = sectionPermissions.actions.find((act) => act.name === actionName);
    return action.allowed;
  };

  useEffect(() => {
    
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    localStorage.removeItem('selectedRows');

    if (parsedAuthState?.token) {
      setPermissions(parsedAuthState.permissions);
      setRole(parsedAuthState.user.role.name);
      fetchVehicules(parsedAuthState.token);
      fetchChauffeurs(parsedAuthState.token);
      const intervalId = setInterval(() => {
        setErrors({ error: false, message: '' });
        setErrorsModifier({ error: false, message: '' });
      }, 10000);

      // Cleanup interval on component unmount
      return () => clearInterval(intervalId);
    } else {
      console.error('Token does not exist');
    }
  }, []);
  //  
  // Function to fetch Vehicules
  const fetchVehicules = async (token) => {

    try {
      const response = await axios.get(`${API}/vehicules`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setVehicules(response.data.data);
    } catch (error) {
      console.error('Error fetching Vehicules:', error);
      setErrors({ error: true, message: 'Failed to fetch Vehicules' });
    }

  };

  const [chauffeurs, setChauffeurs] = useState([]);
  const fetchChauffeurs = async (token) => {
    try {
      const response = await axios.get(`${API}/chauffeurs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setChauffeurs(response.data.data);
    } catch (error) {
      console.error('Error fetching Chauffeurs:', error);
      setErrors({ error: true, message: 'Failed to fetch Chauffeurs' });
    }
  };

  {/* begin modal ajouter Vehicule  */ }

  // ADD
const [isSavingVehicule, setIsSavingVehicule] = useState(false);
const handleAjouterVehicule = async () => {
  if (isSavingVehicule) return;
  const stored = sessionStorage.getItem('authLocalstorage');
  const parsed = stored ? JSON.parse(stored) : null;
  const token = parsed?.token;
  if (!token) { setErrors({ error: true, message: "Session expirée." }); return; }

  // helpers (scoped, unique names)
  const v_toStr  = (v) => { const s = String(v ?? '').trim(); return s || null; };
  const v_toNum  = (v) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : null; };
  const v_toInt  = (v) => { const n = parseInt(v, 10); return Number.isFinite(n) ? n : null; };
  const v_toBool = (v) => (String(v) === '1' || v === 1 || v === true || String(v).toLowerCase() === 'oui');
  const v_toISO  = (v) => { const d = dayjs(v); return d.isValid() ? d.format('YYYY-MM-DD') : null; };

  // required
  const required = [
    ['code_vehicule', 'Code véhicule'],
    ['id_chauffeur', 'Chauffeur'],
    ['marque', 'Marque'],
    ['matricule', 'Matricule'],
    ['type_moyen', 'Type moyen']
  ];
  const miss = required.filter(([k]) => !newVehicule[k] || String(newVehicule[k]).trim() === '');
  if (miss.length) {
    setErrors({ error: true, message: `Champs requis: ${miss.map(([,l])=>l).join(', ')}` });
    return;
  }

  // prevent dup by local list (optional if you avez vehicules en state)
  if (Array.isArray(Vehicules)) {
    const exists = Vehicules.some(v => String(v.code_vehicule).trim().toLowerCase() === String(newVehicule.code_vehicule).trim().toLowerCase());
    if (exists) { setErrors({ error:true, message:"Code véhicule déjà utilisé." }); return; }
  }

  // leasing conditional requirements
  if (String(newVehicule.type_acquisition).toLowerCase() === 'leasing') {
    const leasingMissing = [];
    if (!newVehicule.date_premier_prelevement) leasingMissing.push('Date premier prélèvement');
    if (!newVehicule.date_dernier_prelevement) leasingMissing.push('Date dernier prélèvement');
    if (!newVehicule.montant_loyer_ttc) leasingMissing.push('Montant loyer TTC');
    if (!newVehicule.nombre_prelevements) leasingMissing.push('Nombre prélèvements');
    if (leasingMissing.length) {
      setErrors({ error:true, message:`Champs leasing requis: ${leasingMissing.join(', ')}` });
      return;
    }
  }

  const body = {
    code_vehicule: v_toStr(newVehicule.code_vehicule),
    id_chauffeur:  v_toInt(newVehicule.id_chauffeur),
    marque:        v_toStr(newVehicule.marque),
    matricule:     v_toStr(newVehicule.matricule),
    type_moyen:    v_toStr(newVehicule.type_moyen), // inclut "Tracteur" côté UI
    numero_chassis: v_toStr(newVehicule.numero_chassis),

    premiere_mise_en_circulation: v_toISO(newVehicule.premiere_mise_en_circulation),
    premiere_mise_au_maroc:       v_toISO(newVehicule.premiere_mise_au_maroc),

    ptac:        v_toNum(newVehicule.ptac),
    poids_vide:  v_toNum(newVehicule.poids_vide),

    date_acquisition: v_toISO(newVehicule.date_acquisition),

    type_acquisition: v_toStr(newVehicule.type_acquisition),
    valeur_achat:     v_toNum(newVehicule.valeur_achat),

    date_premier_prelevement: v_toISO(newVehicule.date_premier_prelevement),
    date_dernier_prelevement: v_toISO(newVehicule.date_dernier_prelevement),
    nombre_prelevements:      v_toInt(newVehicule.nombre_prelevements),
    montant_loyer_ttc:        v_toNum(newVehicule.montant_loyer_ttc),

    carburant: v_toStr(newVehicule.carburant),

    numero_police_assurance:  v_toStr(newVehicule.numero_police_assurance),
    date_expiration_assurance: v_toISO(newVehicule.date_expiration_assurance),

    gps_installe: v_toBool(newVehicule.gps_installe),
    statut:       v_toStr(newVehicule.statut) || 'actif',
  };

  try {
    setIsSavingVehicule(true);
    const res = await axios.post(`${API}/vehicules`, body, {
      headers: { Authorization: `Bearer ${token}` },
    });

    handleClose();
    setAlertOpen(true);
    await fetchVehicules(token);

    setNewVehicule({
      code_vehicule: '',
      id_chauffeur: '',
      marque: '',
      matricule: '',
      type_moyen: '',
      numero_chassis: '',
      premiere_mise_en_circulation: '',
      premiere_mise_au_maroc: '',
      ptac: '',
      poids_vide: '',
      date_acquisition: '',
      type_acquisition: '',
      valeur_achat: '',
      date_premier_prelevement: '',
      date_dernier_prelevement: '',
      nombre_prelevements: '',
      montant_loyer_ttc: '',
      carburant: '',
      numero_police_assurance: '',
      date_expiration_assurance: '',
      gps_installe: false,
      statut: 'actif',
    });

    setErrors({ error:false, message:'' });
    logOperation({
      operation_type: "AJOUT",
      entity_type: "Vehicule",
      entity_id: parsed?.user?.id,
      description: `Ajout véhicule ${res?.data?.data?.code_vehicule || ''}`,
    });
  } catch (e) {
    const msg = e?.response?.data?.message || e?.response?.data?.error || "Échec lors de l'ajout du véhicule.";
    setErrors({ error:true, message: msg });
    console.error(e?.response?.data || e);
  } finally {
    setIsSavingVehicule(false);
  }
};

  const isAllowedAjouterVehicule = getPermission(Permissions, 'Vehicules', 'ajouter vehicule');
  const isAllowedModifierVehicule = getPermission(Permissions, 'Vehicules', 'modifier vehicule');
  const isAllowedSupprimerVehicule = getPermission(Permissions, 'Vehicules', 'supprimer vehicule');
  const isAllowedExporterVehicule = getPermission(Permissions, 'Vehicules', 'exporter vehicule');
  const isAllowedImporterVehicule = getPermission(Permissions, 'Vehicules', 'importer vehicule');
  return (
    <ThemeProvider theme={theme}>
      {role === 'user' || role === 'admin' || role === 'super-admin' || role === 'user-facture' ? (
        <Box sx={{
          flexGrow: 1,
          backgroundColor: '#f8fafc',
          padding: { xs: '16px', md: '20px' },
          minHeight: '116vh',
          transition: 'all 0.3s ease-in-out'
        }}>
          <MenuButton />
          <Box sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb',
            overflow: 'hidden'
          }}>
            <DataGridTable data={Vehicules} columns={columns} />
          </Box>
        </Box>
      ) : null}


      {/* begin model ajouter Vehicule  */}
      <BasicModal
        widthSpecial="70%"
        open={openAjouterVehicule}
        onClose={handleClose}
        ChildrenContent={
          <Box >
            <Typography variant="h5" sx={{ fontSize: { lg: '40px', md: '30px', sm: '30px', xs: '20px' }, mb: 1, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', p: '15px' }}>
              Nouveau Véhicule
            </Typography>

            <Grid container sx={{ height: '500px', maxHeight: '600px', overflowY: 'auto' , display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', color: '#1D3E62', gap: 1.5 }}>
              <Grid item xs={12} md={5}>
                <TextInputMui
                  required
                  label="Code véhicule"
                  type="text"
                  value={newVehicule.code_vehicule}
                  setValue={(e) => setNewVehicule({ ...newVehicule, code_vehicule: e })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <TextInputMui
                  required
                  label="Marque"
                  type="text"
                  value={newVehicule.marque}
                  setValue={(e) => setNewVehicule({ ...newVehicule, marque: e })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <TextInputMui
                  required
                  label="Matricule"
                  type="text"
                  value={newVehicule.matricule}
                  setValue={(e) => setNewVehicule({ ...newVehicule, matricule: e })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <AutocompleteComboBox
                  required
                  widthSpecific="100%"
                  Label="Type de moyen"
                  list={[
                    { id: "taxi", Nom: "Taxi" },
                    { id: "T3_5", Nom: "Camion lourd T3/5" },
                    { id: "T7", Nom: "Camion léger T7" },
                    { id: "T14", Nom: "Camion lourd T14" },
                    { id: "T18", Nom: "Camion lourd T18" },
                    { id: "semi_remorque", Nom: "Semi remorque" },
                    { id: "Tracteur", Nom: "Tracteur" },
                  ]}
                  keyField="id"
                  valueField="Nom"
                  value={newVehicule.type_moyen}
                  onChange={(v) => setNewVehicule({ ...newVehicule, type_moyen: v })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <AutocompleteComboBox
                  required
                  Label="Chauffeur responsable"
                  widthSpecific="100%"
                  keyField="id"
                  valueField="Nom"
                  DeméValue="Prénom"
                  DueValue
                  dueShowValue
                  value={newVehicule.id_chauffeur}
                  onChange={(v) => setNewVehicule({ ...newVehicule, id_chauffeur: v })}
                  list={chauffeurs}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <TextInputMui
                  label="Numéro de châssis"
                  type="text"
                  value={newVehicule.numero_chassis}
                  setValue={(e) => setNewVehicule({ ...newVehicule, numero_chassis: e })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <DateTimePickerComponent
                  typeDate="date"
                  label="Première mise en circulation"
                  value={newVehicule.premiere_mise_en_circulation}
                  dateSelected={(d) => setNewVehicule({ ...newVehicule, premiere_mise_en_circulation: d })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <DateTimePickerComponent
                  typeDate="date"
                  label="Première mise au Maroc"
                  value={newVehicule.premiere_mise_au_maroc}
                  dateSelected={(d) => setNewVehicule({ ...newVehicule, premiere_mise_au_maroc: d })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <TextInputMui
                  label="PTAC"
                  type="number"
                  value={newVehicule.ptac}
                  setValue={(e) => setNewVehicule({ ...newVehicule, ptac: e })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <TextInputMui
                  label="Poids à vide"
                  type="number"
                  value={newVehicule.poids_vide}
                  setValue={(e) => setNewVehicule({ ...newVehicule, poids_vide: e })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <DateTimePickerComponent
                  typeDate="date"
                  label="Date d’acquisition"
                  value={newVehicule.date_acquisition}
                  dateSelected={(d) => setNewVehicule({ ...newVehicule, date_acquisition: d })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <AutocompleteComboBox
                  Label="Type d’acquisition"
                  widthSpecific="100%"
                  list={[
                    { id: "leasing", Nom: "Leasing" },
                    { id: "comptant", Nom: "Comptant" },
                  ]}
                  keyField="id"
                  valueField="Nom"
                  value={newVehicule.type_acquisition}
                  onChange={(v) =>
                    setNewVehicule((prev) => ({
                      ...prev,
                      type_acquisition: v,
                      ...(v === "leasing"
                        ? {}
                        : {
                          date_premier_prelevement: "",
                          date_dernier_prelevement: "",
                          nombre_prelevements: "",
                          montant_loyer_ttc: "",
                        }),
                    }))
                  }
                />
              </Grid>

              {newVehicule.type_acquisition === "leasing" && (
                <>
                  <Grid item xs={12} md={5}>
                    <DateTimePickerComponent
                      typeDate="date"
                      label="Date premier prélèvement"
                      value={newVehicule.date_premier_prelevement}
                      dateSelected={(d) => setNewVehicule({ ...newVehicule, date_premier_prelevement: d })}
                    />
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <DateTimePickerComponent
                      typeDate="date"
                      label="Date dernier prélèvement"
                      value={newVehicule.date_dernier_prelevement}
                      dateSelected={(d) => setNewVehicule({ ...newVehicule, date_dernier_prelevement: d })}
                    />
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextInputMui
                      label="Nombre de prélèvements"
                      type="number"
                      value={newVehicule.nombre_prelevements}
                      setValue={(e) => setNewVehicule({ ...newVehicule, nombre_prelevements: e })}
                    />
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextInputMui
                      label="Montant loyer TTC"
                      type="number"
                      value={newVehicule.montant_loyer_ttc}
                      setValue={(e) => setNewVehicule({ ...newVehicule, montant_loyer_ttc: e })}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} md={5}>
                <TextInputMui
                  label="Valeur d’achat"
                  type="number"
                  value={newVehicule.valeur_achat}
                  setValue={(e) => setNewVehicule({ ...newVehicule, valeur_achat: e })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <AutocompleteComboBox
                  Label="Carburant"
                  widthSpecific="100%"
                  keyField="id"
                  valueField="Nom"
                  value={newVehicule.carburant}
                  onChange={(v) => setNewVehicule({ ...newVehicule, carburant: v })}
                  list={[
                    { id: "Diesel", Nom: "Diesel" },
                    { id: "Essence", Nom: "Essence" },
                    { id: "Electrique", Nom: "Électrique" },
                    { id: "Hybride", Nom: "Hybride" },
                  ]}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <TextInputMui
                  label="N° police d’assurance"
                  type="text"
                  value={newVehicule.numero_police_assurance}
                  setValue={(e) => setNewVehicule({ ...newVehicule, numero_police_assurance: e })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <DateTimePickerComponent
                  typeDate="date"
                  label="Date d’expiration assurance"
                  value={newVehicule.date_expiration_assurance}
                  dateSelected={(d) => setNewVehicule({ ...newVehicule, date_expiration_assurance: d })}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!newVehicule.gps_installe}
                      onChange={(e) => setNewVehicule({ ...newVehicule, gps_installe: e.target.checked })}
                      color="primary"
                    />
                  }
                  label="GPS installé"
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <AutocompleteComboBox
                  Label="Statut"
                  widthSpecific="100%"
                  list={[
                    { id: "actif", Nom: "Actif" },
                    { id: "inactif", Nom: "Inactif" },
                    { id: "vendu", Nom: "Vendu" },
                    { id: "endommagé", Nom: "Endommagé" },
                  ]}
                  keyField="id"
                  valueField="Nom"
                  value={newVehicule.statut}
                  onChange={(v) => setNewVehicule({ ...newVehicule, statut: v })}
                />
              </Grid>

              

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                
              </Grid>
            </Grid>
            {errors.error && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1" sx={{ color: 'red', textAlign: 'center' }}>
                    {errors.message}
                  </Typography>
                </Grid>
              )}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ButtonAttribute
                    type="submit"
                    Label="Ajouter"
                    color="white"
                    Bgcolor="#28A745"
                    height="60px"
                    width="50%"
                    action={handleAjouterVehicule}
                  />
                </Box>
          </Box>
        }
      />

      {/* end  model ajouter Vehicule */}

      {/* begin model modifier Vehicule and multiple Vehicules */}
      <BasicModal
        open={openModifierVehicule}
        onClose={handleCloseModifier}
        widthSpecial="70%"
        ChildrenContent={
          rowsSelected.length === 1 ? (
            <Box sx={{ maxHeight: '85vh', overflowY: 'auto', px: 3 }}>
              <Typography variant="h4" sx={{ fontSize: { lg: '40px', md: '30px', sm: '25px', xs: '20px' }, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', p: '20px' }}>
                Modifier le Véhicule ID : {rowsSelected[0].id}
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextInputMui
                    required
                    label="Code véhicule"
                    type="text"
                    value={modifierVehicule.code_vehicule}
                    setValue={(e) => setModifierVehicule({ ...modifierVehicule, code_vehicule: e })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextInputMui
                    required
                    label="Marque"
                    type="text"
                    value={modifierVehicule.marque}
                    setValue={(e) => setModifierVehicule({ ...modifierVehicule, marque: e })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextInputMui
                    required
                    label="Matricule"
                    type="text"
                    value={modifierVehicule.matricule}
                    setValue={(e) => setModifierVehicule({ ...modifierVehicule, matricule: e })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <AutocompleteComboBox
                    required
                    Label="Type de moyen"
                    widthSpecific="100%"
                    list={[
                      { id: "taxi", Nom: "Taxi" },
                      { id: "T3_5", Nom: "Camion lourd T3/5" },
                      { id: "T7", Nom: "Camion léger T7" },
                      { id: "T14", Nom: "Camion lourd T14" },
                      { id: "T18", Nom: "Camion lourd T18" },
                      { id: "semi_remorque", Nom: "Semi remorque" },
                      { id: "Tracteur", Nom: "Tracteur" },
                    ]}
                    keyField="id"
                    valueField="Nom"
                    value={modifierVehicule.type_moyen}
                    onChange={(v) => setModifierVehicule({ ...modifierVehicule, type_moyen: v })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <AutocompleteComboBox
                    required
                    Label="Chauffeur responsable"
                    widthSpecific="100%"
                    keyField="id"
                    valueField="Nom"
                    DeméValue="Prénom"
                    DueValue
                    dueShowValue
                    list={chauffeurs}
                    value={modifierVehicule.id_chauffeur}
                    onChange={(v) => setModifierVehicule({ ...modifierVehicule, id_chauffeur: v })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextInputMui
                    label="Numéro de châssis"
                    type="text"
                    value={modifierVehicule.numero_chassis}
                    setValue={(e) => setModifierVehicule({ ...modifierVehicule, numero_chassis: e })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <DateTimePickerComponent
                    typeDate="date"
                    label="Première mise en circulation"
                    value={dayjs(modifierVehicule.premiere_mise_en_circulation).format('YYYY-MM-DD')}
                    dateSelected={(d) => setModifierVehicule({ ...modifierVehicule, premiere_mise_en_circulation: d })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <DateTimePickerComponent
                    typeDate="date"
                    label="Première mise au Maroc"
                    value={dayjs(modifierVehicule.premiere_mise_au_maroc).format('YYYY-MM-DD')}
                    dateSelected={(d) => setModifierVehicule({ ...modifierVehicule, premiere_mise_au_maroc: d })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextInputMui
                    label="PTAC"
                    type="number"
                    value={modifierVehicule.ptac}
                    setValue={(e) => setModifierVehicule({ ...modifierVehicule, ptac: e })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextInputMui
                    label="Poids à vide"
                    type="number"
                    value={modifierVehicule.poids_vide}
                    setValue={(e) => setModifierVehicule({ ...modifierVehicule, poids_vide: e })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <DateTimePickerComponent
                    typeDate="date"
                    label="Date d’acquisition"
                    value={dayjs(modifierVehicule.date_acquisition).format('YYYY-MM-DD')}
                    dateSelected={(d) => setModifierVehicule({ ...modifierVehicule, date_acquisition: d })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <AutocompleteComboBox
                    Label="Type d’acquisition"
                    widthSpecific="100%"
                    list={[
                      { id: "leasing", Nom: "Leasing" },
                      { id: "comptant", Nom: "Comptant" },
                    ]}
                    keyField="id"
                    valueField="Nom"
                    value={modifierVehicule.type_acquisition}
                    onChange={(v) =>
                      setModifierVehicule((prev) => ({
                        ...prev,
                        type_acquisition: v,
                        ...(v === "leasing"
                          ? {}
                          : {
                            date_premier_prelevement: "",
                            date_dernier_prelevement: "",
                            nombre_prelevements: "",
                            montant_loyer_ttc: "",
                          }),
                      }))
                    }
                  />
                </Grid>

                {modifierVehicule.type_acquisition === "leasing" && (
                  <>
                    <Grid item xs={12} md={6}>
                      <DateTimePickerComponent
                        typeDate="date"
                        label="Date premier prélèvement"
                        value={ dayjs(modifierVehicule.date_premier_prelevement).format('YYYY-MM-DD')}
                        dateSelected={(d) => setModifierVehicule({ ...modifierVehicule, date_premier_prelevement: d })}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <DateTimePickerComponent
                        typeDate="date"
                        label="Date dernier prélèvement"
                        value={dayjs(modifierVehicule.date_dernier_prelevement).format('YYYY-MM-DD')}
                        dateSelected={(d) => setModifierVehicule({ ...modifierVehicule, date_dernier_prelevement: d })}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextInputMui
                        label="Nombre de prélèvements"
                        type="number"
                        value={modifierVehicule.nombre_prelevements}
                        setValue={(e) => setModifierVehicule({ ...modifierVehicule, nombre_prelevements: e })}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextInputMui
                        label="Montant loyer TTC"
                        type="number"
                        value={modifierVehicule.montant_loyer_ttc}
                        setValue={(e) => setModifierVehicule({ ...modifierVehicule, montant_loyer_ttc: e })}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} md={6}>
                  <TextInputMui
                    label="Valeur d’achat"
                    type="number"
                    value={modifierVehicule.valeur_achat}
                    setValue={(e) => setModifierVehicule({ ...modifierVehicule, valeur_achat: e })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <AutocompleteComboBox
                    Label="Carburant"
                    widthSpecific="100%"
                    keyField="id"
                    valueField="Nom"
                    list={[
                      { id: "Diesel", Nom: "Diesel" },
                      { id: "Essence", Nom: "Essence" },
                      { id: "Electrique", Nom: "Électrique" },
                      { id: "Hybride", Nom: "Hybride" },
                    ]}
                    value={modifierVehicule.carburant}
                    onChange={(v) => setModifierVehicule({ ...modifierVehicule, carburant: v })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextInputMui
                    label="N° police d’assurance"
                    type="text"
                    value={modifierVehicule.numero_police_assurance}
                    setValue={(e) => setModifierVehicule({ ...modifierVehicule, numero_police_assurance: e })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <DateTimePickerComponent
                    typeDate="date"
                    label="Date d’expiration assurance"
                    value={modifierVehicule.date_expiration_assurance}
                    dateSelected={(d) => setModifierVehicule({ ...modifierVehicule, date_expiration_assurance: d })}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={!!(modifierVehicule.gps_installe === 1 || modifierVehicule.gps_installe === true)}
                        onChange={(e) => setModifierVehicule({ ...modifierVehicule, gps_installe: e.target.checked })}
                        color="primary"
                      />
                    }
                    label="GPS installé"
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <AutocompleteComboBox
                    Label="Statut"
                    widthSpecific="100%"
                    keyField="id"
                    valueField="Nom"
                    list={[
                      { id: "actif", Nom: "Actif" },
                      { id: "inactif", Nom: "Inactif" },
                      { id: "vendu", Nom: "Vendu" },
                      { id: "endommagé", Nom: "Endommagé" },
                    ]}
                    value={modifierVehicule.statut}
                    onChange={(v) => setModifierVehicule({ ...modifierVehicule, statut: v })}
                  />
                </Grid>

                <Grid item xs={12} sx={{ mt: 3 }}>
                  <Typography variant="h6" sx={{ fontSize: '16px', color: '#e00707ff', textAlign: 'center' }}>
                    {errorsModifer.message}
                  </Typography>
                </Grid>

                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ButtonAttribute
                    type="submit"
                    Label="Modifier"
                    color="white"
                    Bgcolor="#28A745"
                    height="60px"
                    width="300px"
                    action={handleOpenModifierOneVehicule}
                  />
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: "20px", md: "20px", sm: "20px", xs: "20px" },
                mb: 2,
                fontFamily: "Montserrat , sans-serif",
                color: "#1D3E62",
                textAlign: "center",
                fontWeight: "600",
                p: "20px",
              }}
            >
              Opération invalide.
            </Typography>
          )
        }
      />



      {/* end  model modifier Vehicule and multiple Vehicules */}

      {/* Begin model Delete Vehicule  and multiple Vehicules */}
      <BasicModal
        open={openDeleteVehicule}
        onClose={handleCloseDeleteVehicule}
        ChildrenContent={
          rowsSelected.length === 1 ? <><Box>
            <Typography variant='h4' sx={{
              fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

              fontFamily: 'Montserrat , sans-serif',
              color: '#1D3E62',
              textAlign: 'center',
              fontWeight: 'bold',
              padding: '10px'
            }}>
              Suppression de la Vehicule ID : {rowsSelected[0].id} </Typography>

            <Typography variant='h6' sx={{
              fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
              mb: 1,
              fontFamily: 'Montserrat , sans-serif',
              color: '#1D3E62',
              textAlign: 'center',

              padding: '20px'
            }} >Voulez-vous vraiment supprimer cette Vehicule ?</Typography>
            <Box
              sx={{
                display: { xs: 'grid', sm: 'grid', md: 'grid', lg: 'flex', xl: 'flex' },
                justifyContent: 'space-evenly', alignItems: 'center', gap: '20px'
              }} >

              <ButtonAttribute
                type="submit"
                Label="Annuler"
                color={'white'}
                Bgcolor='gray'
                height={'50px'}
                width={'100%'}
                action={handleCloseDeleteVehicule}
              />
              <ButtonAttribute
                type="submit"
                Label="Supprimer"
                color={'white'}
                Bgcolor='#DC3545'
                height={'50px'}
                width={'100%'}
                action={handleOpenConfirmationPassword}
              />

            </Box>


          </Box></> :
            <><Box>
              <Typography variant='h4' sx={{
                fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
                fontFamily: 'Montserrat , sans-serif',
                color: '#1D3E62',
                textAlign: 'center',
                fontWeight: 'bold',
                padding: '10px'
              }}>
                Suppression des Vehicules sélectionnées  </Typography>

              <Typography variant='h6' sx={{
                fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                mb: 1,
                fontFamily: 'Montserrat , sans-serif',
                color: '#1D3E62',
                textAlign: 'center',
                padding: '20px'
              }} >Voulez-vous vraiment supprimer toutes les Vehicules sélectionnées ?</Typography>

              {rowsSelected.length > 1 ? (
                <Box sx={{ justifyContent: "center", display: 'flex', gap: '5px', width: '100%', overflowX: 'auto', marginBottom: '20px' }}>
                  {rowsSelected.map((row, index) => (
                    <Box
                      key={index} // Use a unique key. Ideally, use a unique identifier from `row` if available.
                      sx={{
                        display: 'grid',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '20px',

                        padding: '10px',
                        width: '50px',
                        height: '40px',
                        borderRadius: '10%',
                        backgroundColor: '#DC3545',
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          color: '#fff',
                          fontSize: 14,
                          textAlign: 'center',
                          fontFamily: 'Montserrat, sans-serif',
                        }}
                      >
                        {row.id || 'N/A'} {/* Safeguard in case `id` is undefined */}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : null}




              <Box
                sx={{
                  display: { xs: 'grid', sm: 'grid', md: 'grid', lg: 'flex', xl: 'flex' },
                  justifyContent: 'space-evenly', alignItems: 'center', gap: '20px'
                }} >

                <ButtonAttribute
                  type="submit"
                  Label="Annuler"
                  color={'white'}
                  Bgcolor='gray'
                  height={'50px'}
                  width={'100%'}
                  action={handleCloseDeleteVehicule}
                />
                <ButtonAttribute
                  type="submit"
                  Label="Supprimer toutes"
                  color={'white'}
                  Bgcolor='#DC3545'
                  height={'50px'}
                  width={'100%'}
                  action={handleOpenConfirmationPassword}
                />

              </Box>


            </Box></>}
      />
      {/* end model Delete Vehicule  and multiple Vehicules */}

      {/* begin model export Vehicule */}
      <BasicModal
        open={openExtrationVehicule}
        onClose={handleCloseExtrationVehicule}
        ChildrenContent={<><Box>
          <Typography variant='h4' sx={{
            fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            fontWeight: 'bold',
            padding: '10px'
          }}>
            Extraction des données des Vehicules </Typography>

          <Typography variant='h6' sx={{
            fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
            mb: 1,
            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            padding: '20px'
          }} >Vous disposez de deux types d'extraction des transactions. Si vous souhaitez extraire l'intégralité des données ou uniquement certains éléments, merci de les préciser dans le tableau.</Typography>

          <Box
            sx={{
              display: 'grid',
              alignItems: 'center', gap: '2px'
            }} >

            <ButtonAttribute
              type="button"
              Label="Extraire toutes les données ( XLSX )"
              Bgcolor='#17A2B8'
              color='white'
              bgColorHover={'#117A8B'}
              height={'70px'}
              width={'100%'}
              endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
              action={handleExtrationAllVehicule}
            />
            <ButtonAttribute
              type="submit"
              Label="Extraire les données sélectionnées ( XLSX )"
              Bgcolor='#17A2B8'
              color='white'
              bgColorHover={'#117A8B'}
              height={'70px'}
              width={'100%'}
              action={handleExtrationSelectionsVehicules}
              endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
            />

          </Box>


        </Box></>}
      />
      {/* end  model export Vehicule */}

      {/* begin model importation Vehicule */}
      <BasicModal
        open={openImportationVehicule}
        onClose={handleCloseImportationVehicule}
        ChildrenContent={<><Box>
          <Typography variant='h4' sx={{
            fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            fontWeight: 'bold',
            padding: '10px'
          }}>
            Importation des données des Vehicules </Typography>

          <Typography variant='h6' sx={{
            fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
            mb: 1,
            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            padding: '20px'
          }} > Veuillez utiliser ce formulaire pour importer les Vehicules depuis un fichier Excel </Typography>
          <ButtonAttribute
            type="button"
            Label="Télécharger le formulaire Excel"
            Bgcolor='#17A2B8'
            color='white'
            bgColorHover={'#117A8B'}
            height={'80px'}
            width={'100%'}
            endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
            action={handleDownload}
          />
          <Divider />
          <Box
            sx={{
              display: 'grid',
              justifyContent: 'space-evenly', alignItems: 'center',

            }} >
            <Typography variant='h6' sx={{
              fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
              mb: 1,
              fontFamily: 'Montserrat , sans-serif',
              color: '#1D3E62',
              textAlign: 'center',
              padding: '20px'
            }} > Cliquez sur le bouton ci-dessous pour sélectionner et importer votre fichier.</Typography>
            <ButtonAttribute
              type="button"
              Label="Importer toutes les données de Vehicules"
              Bgcolor='#17A2B8'
              color='white'
              bgColorHover={'#117A8B'}
              height={'70px'}
              width={'100%'}
              endIcon={<FontAwesomeIcon icon={faCloudArrowUp} color='white' />}
              action={triggerFileInput}
            />
            <input
              id="file-upload"
              type="file"
              accept=".xlsx, .xls , .csv"
              style={{ display: 'none' }}
              onChange={handleFileImport}
            />
            <CustomizedProgressBars value={isLoading} color={isLoading === 100 ? 'success' : isLoading === 57 ? 'error' : 'gray'} />
          </Box>


        </Box></>}
      />

      {/* end model importation Vehicule */}

      {/* begin model confirmation password delete Vehicules */}

      <BasicModal
        open={openConfirmationPassword}
        onClose={handleCloseConfirmationPassword}
        ChildrenContent={<><Box>
          <Typography variant='h4' sx={{
            fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
            fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center',
            fontWeight: 'bold', padding: '20px', marginBottom: '20px'
          }}>
            Veuillez saisir votre mot de passe pour confirmer la suppression de la Vehicule
          </Typography>
          <Box sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
            <TextInputMui
              type="password"
              label="Mot de passe"
              name="password"
              value={ConfrimedPassword.password}
              setValue={(e) => setConfirmedPassword({ ...ConfrimedPassword, password: e })}
              required
            />
            <ButtonAttribute
              type="submit"
              Label="Confirmer la suppression"
              Bgcolor='#17A2B8'
              color='white'
              bgColorHover={'#117A8B'}
              height={'50px'}
              width={'100%'}
              endIcon={<FontAwesomeIcon icon={faCheck} color='white' />}
              action={handleVerificationPassword}
            />

          </Box>
        </Box></>} />


      {/* alert for ajouter */}
      <AlertBar
        open={alertOpen}
        onClose={handleAlertClose}
        textContent="La Vehicule a été ajoutée avec succès."
        alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      {/* alert for ajouter */}

      {/* alert for modifier */}
      <AlertBar
        open={alertOpenSelectedModifier}
        onClose={handleAlertCloseSelectedModifier}
        textContent="Veuillez choisir une ligne"
        alertColor="warning"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      {/* not modifer line  row  */}
      <AlertBar
        open={alertOpenNotModiferRow}
        onClose={handleAlertCloseNotModiferRow}
        textContent={"Aucune des informations n'a été modifiée, donc je ne vais pas effectuer l'opération."}
        alertColor={"info"}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      {/*  alert for modifier success */}
      <AlertBar
        open={alertOpenUpdatedVehicule}
        onClose={handleAlertCloseUpdatedVehicule}
        textContent="Vehicule mise à jour avec succès" alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      {/*  alert for modifier  */}

      {/* alert for delete Vehicule one row  */}
      <AlertBar
        open={alertOpenDeletedVehicule}
        onClose={handleAlertCloseDeletedVehicule}
        textContent="Vehicule supprimée avec succès " alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      <AlertBar
        open={alertOpenPasswordNotValid}
        onClose={handleAlertClosePasswordNotValid}
        textContent="Mot de passe incorrect pour supprimer la Vehicule" alertColor="error"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      <AlertBar
        open={alertOpenMultiDeletedVehicule}
        onClose={handleAlertMultiCloseDeletedVehicule}
        textContent="Toutes les Vehicules ont été supprimées avec succès." alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      {/* end alert for delete Vehicule one row  */}

      {/* alert for extration Vehicule   */}
      <AlertBar
        open={alertOpenNotSelectedLineExtration}
        onClose={handleAlertCloseNotSelectedLineExtration}
        textContent={"Veuillez préciser les lignes que vous souhaitez extraire pour télécharger le fichier au format .csv"}
        alertColor={"info"}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      {/* alert for importation Vehicule   */}
      <AlertBar
        open={alertOpenImport}
        onClose={handleCloseAlertImport}
        textContent="Importation effectuée avec succès ! Les données ont été ajoutées correctement"
        alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      <AlertBar
        open={alertErrorImport}
        onClose={handleCloseErrorAlertImport}
        textContent="Importation non effectuée : le fichier contient des erreurs ou les valeurs sont incorrectes. Veuillez vérifier et réessayer."
        alertColor="error"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      {/* end alert for importation Vehicule   */}

      {/* begin alert confirmation password delete Vehicules */}
      <AlertBar
        open={alertOpenConfirmDeleteVehicule}
        onClose={handleCloseAlertConfirmDeleteVehicule}
        textContent="le mot de passe est incorrect !"
        alertColor="error"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      {/* end alert confirmation password delete Vehicules */}



    </ThemeProvider>
  );
};


